import {Model} from './Model';
import {InfoButtonText} from './InfoButtonText';
import {SessionStorageObject} from '../Utilities/SessionStorageObject';

export class Product extends Model implements SessionStorageObject {
  public sortOrder: number = 0;
  public descriptionExternal: string = '';
  public descriptionWebShop: string = '';
  public productNumber: string = '';
  public eventId: number = 0;
  public image: string = '';
  public price: number = 0;
  public monetaryBenefit: number = 0;
  public parentProduct: number = 0;
  public currency: string = '';
  public includingVat: number = 0;
  public publicationDateStart: Date = new Date();
  public publicationDateEnd: Date = new Date();
  public bookingPosStart: Date = new Date();
  public bookingPosEnd: Date = new Date();
  public localPubTransIncluded: number = 0;
  public slotId: number = 0;
  public slots: Array<number> = [];
  public registrationRequired: string = '';
  public productGroups: Array<number> = [];
  public visitorSegmentId: number = 0;
  public countsFirstDayAdmissions: number = 0;
  public numberFirstDayAdmissions: number = 0;
  public poeSignalling: number = 0;
  public accessAreaId: number = 0;
  public accessAreaIdToCountsAdmission: Array<any> = [];
  public externalAccessId: number = 0;
  public referralMarketingCodes: number = 0;
  public referralMarketingCodeSource: number = 0;
  public printShop: Array<any> = [];
  public translations: Array<any> = [];
  public vatRates: Array<any> = [];
  public minOrderQuantity: number = 1;
  public maxOrderQuantity: number | null = null;
  public maxOrderQuantityRestriction: number | null = null;
  public distributionChannelId: number = 1;
  public bookingUnavailableHint: string = '';
  public additionalProduct: boolean|null = false;
  public infoButtonText: InfoButtonText|null = null;
  public redeemType: RedeemTyping | null = null;

  constructor(data: any) {
    super(data);
    this.sortOrder = data.sortOrder;
    this.descriptionExternal = data.descriptionExternal;
    this.descriptionWebShop = data.descriptionWebShop;
    this.productNumber = data.productNumber;
    this.eventId = data.eventId;
    this.parentProduct = data.parentProduct;
    this.image = data.image;
    this.price = data.price;
    this.monetaryBenefit = data.monetaryBenefit;
    this.currency = data.currency;
    this.includingVat = data.includingVat;
    this.publicationDateStart = data.publicationDateStart;
    this.publicationDateEnd = data.publicationDateEnd;
    this.bookingPosStart = data.bookingPosStart;
    this.bookingPosEnd = data.bookingPosEnd;
    this.localPubTransIncluded = data.localPubTransIncluded;
    this.slotId = data.slotId;
    this.slots = data.slots;
    this.registrationRequired = data.registrationRequired;
    this.productGroups = data.productGroups;
    this.visitorSegmentId = data.visitorSegmentId;
    this.countsFirstDayAdmissions = data.countsFirstDayAdmissions;
    this.numberFirstDayAdmissions = data.numberFirstDayAdmissions;
    this.poeSignalling = data.poeSignalling;
    this.accessAreaId = data.accessAreaId;
    this.accessAreaIdToCountsAdmission = data.accessAreaIdToCountsAdmission;
    this.externalAccessId = data.externalAccessId;
    this.referralMarketingCodes = data.referralMarketingCodes;
    this.referralMarketingCodeSource = data.referralMarketingCodeSource;
    this.printShop = data.printShop;
    this.translations = data.translations;
    this.vatRates = data.vatRates;
    this.minOrderQuantity = data.minOrderQuantity;
    this.maxOrderQuantity = data.maxOrderQuantity;
    this.maxOrderQuantityRestriction = data.maxOrderQuantityRestriction;
    this.distributionChannelId = data.distributionChannelId;
    this.bookingUnavailableHint = data.bookingUnavailableHint || '';
    this.infoButtonText = data.infoButtonText ? new InfoButtonText(data.infoButtonText) : null;
    this.additionalProduct = data.additionalProduct === null ? data.additionalProduct : Boolean(data.additionalProduct);
    this.infoButtonText = data.infoButtonText ? new InfoButtonText(data.infoButtonText) : null;
    this.redeemType = data.redeemType;
  }

  fromStorage(data: any) {
    return new Product(data);
  }

  toString(): string {
    return `${this.descriptionWebShop}`;
  }

  get isRegistrationRequired() {
    // registrationRequired can be 'Ja', 'Nein' or 'Optional'
    return this.registrationRequired === 'Ja' || this.registrationRequired === '';
  }

  get isRegistrationOptional() {
    // registrationRequired can be 'Ja', 'Nein' or 'Optional'
    return this.registrationRequired === 'Optional';
  }
}
